module.exports = __webpack_public_path__ + "static/img/cjfw-companyProducts5.fef2ca5d.png";